import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { Formik, Form, ErrorMessage } from "formik";
import {
    customStringify,
    error_alert,
    selectStylesField,
    setToken,
    stringNotEmpty,
    success_alert,
} from "../../utils";
import TextField from "../../components/FormikFields/TextField";
import SelectField from "../../components/FormikFields/SelectField";
import DateField from "../../components/FormikFields/DateField";
import { BiEuro, BiLoaderAlt } from "react-icons/bi";
import { Link } from "react-router-dom";
import { login } from "../../redux/slices/userSlice";
import { useDispatch } from "react-redux";
import { email_tl, enter_valid_number, less_than_100_tl, network_tl, positive_only_tl, required_tl } from "../../translations";
import { FormattedMessage, useIntl } from "react-intl";
import useApi from "../../hooks/useApi";
import { BASE_URL, CATEGORIES, EMAIL_REGX, GENDERS, ROLE_INFLUENCER } from "../../constants";
import { FaArrowRightLong, FaArrowLeftLong, FaInstagram, FaTiktok, FaRegCircleCheck } from "react-icons/fa6";
import { IoIosAddCircle, IoMdCreate } from "react-icons/io";
import { HiOutlinePencil, HiCheck } from "react-icons/hi2";
import CurrencyField from "../../components/FormikFields/CurrencyField";
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';

const InfluencerForm = ({ setStep, setFormData, formData }) => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const { Axios } = useApi();
    const [image, setImage] = useState(formData ? formData.picture : null);
    const [selectedPlatforms, setSelectedPlatforms] = useState(formData ? formData.selectedPlatforms : []);

    const initialValues = {
        name: formData ? formData.name : "",
        email: formData ? formData.email : "",
        sur_name: formData ? formData.sur_name : "",
        address: formData ? formData.address : "",
        city: formData ? formData.city : "",
        role: ROLE_INFLUENCER.value,
        niches: formData ? formData.niches : [],
        // niches:  [],
        instagram_name: formData ? formData.instagram_name : "",
        instagram_bio: formData ? formData.instagram_bio : "",
        instagram_followers: formData ? formData.instagram_followers : "",
        instagram_engagement_metrics: formData ? formData.instagram_engagement_metrics : "",
        tiktok_name: formData ? formData.tiktok_name : "",
        tiktok_followers: formData ? formData.tiktok_followers : "",
        tiktok_engagement_metrics: formData ? formData.tiktok_engagement_metrics : "",
        date_of_birth: formData ? formData.date_of_birth : null,
        selectedPlatforms: formData ? formData.selectedPlatforms : [],
        consent: formData ? formData.consent : false,
        marketing: formData ? formData.marketing : false,
        country: formData ? formData.country : "",
        gender: formData ? formData.gender : "",
        average_price: formData ? formData.average_price : "",
        place_id: formData ? formData.place_id : "",
    };

    yup.addMethod(yup.string, "stringNotEmpty", stringNotEmpty);
    const validationSchema = yup.object({
        name: yup.string().stringNotEmpty(),
        email: yup.string().email(email_tl(intl)).required(required_tl(intl)).matches(EMAIL_REGX, email_tl(intl)),
        sur_name: yup.string().stringNotEmpty(),
        address: yup.string().required(required_tl(intl)),
        city: yup.string().stringNotEmpty(),
        niches: yup.array().min(1, required_tl(intl)).required(required_tl(intl)),
        instagram_name: selectedPlatforms?.includes('instagram') ? yup.string().stringNotEmpty() : yup.string(),
        instagram_followers: selectedPlatforms?.includes('instagram') ? yup.number().integer(enter_valid_number(intl)).typeError(enter_valid_number(intl)).min(0, positive_only_tl(intl)).required(required_tl(intl)) : yup.number(),
        instagram_engagement_metrics: selectedPlatforms?.includes('instagram') ? yup.number().typeError(enter_valid_number(intl)).min(0, positive_only_tl(intl)).max(100, less_than_100_tl(intl)).required(required_tl(intl)) : yup.number(),
        instagram_bio: selectedPlatforms?.includes('instagram') ? yup.string().stringNotEmpty() : yup.string(),

        tiktok_name: selectedPlatforms?.includes('tiktok') ? yup.string().stringNotEmpty() : yup.string(),
        tiktok_followers: selectedPlatforms?.includes('tiktok') ? yup.number().integer(enter_valid_number(intl)).typeError(enter_valid_number(intl)).min(0, positive_only_tl(intl)).required(required_tl(intl)) : yup.number(),
        tiktok_engagement_metrics: selectedPlatforms?.includes('tiktok') ? yup.number().typeError(enter_valid_number(intl)).min(0, positive_only_tl(intl)).max(100, less_than_100_tl(intl)).required(required_tl(intl)) : yup.number(),
        date_of_birth: yup.date().required(required_tl(intl)),
        selectedPlatforms: yup.array().min(1, intl.formatMessage({ id: "at_least_one_platform", defaultMessage: "At least one platform is required" })).required(required_tl(intl)),
        consent: yup.bool().oneOf([true], required_tl(intl)).required(required_tl(intl)),
        country: yup.string().required(required_tl(intl)),
        gender: yup.object().required(required_tl(intl)),
        average_price: yup.number().typeError(enter_valid_number(intl)).min(0, positive_only_tl(intl)).required(required_tl(intl)),
    })


    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
            setFormData((prev) => ({ ...prev, picture: file }));
        }
    };

    const handlePlatformSelect = (platform, form) => {
        setSelectedPlatforms((prev = []) => {
            const updatedPlatforms = prev?.includes(platform)
                ? prev?.filter((p) => p !== platform)
                : [...prev, platform];

            form.setFieldValue("selectedPlatforms", updatedPlatforms);
            return updatedPlatforms;
        });
    };


    const handleSubmit = async (values, formikBag) => {
        // console.log("values", values);
        setFormData({ ...formData, ...values });
        setStep(2);
    };


    const handleAddressSelect = (place, form) => {

        const terms = place.value.terms;
        const address = place?.label || "";

        console.log(address, "place");
        form.setFieldValue("address", address);

        let city = '';
        let country = '';

        terms.forEach((term, index) => {

            if (index === terms.length - 2) {
                city = term.value;
            }

            if (index === terms.length - 1) {
                country = term.value;
            }
        });

        form.setFieldValue('city', city);
        form.setFieldValue('country', country);
        form.setFieldValue('place_id', place.value.place_id);

        console.log('City:', city);
        console.log('Country:', country);
    };


    return (
        <>
            <h1 className='text-3xl font-bold text-t-light'>
                <FormattedMessage id="influencer_registration" defaultMessage={"Influencer Registration"} />
            </h1>
            <p className='text-start text-sm text-t-light w-[90%]'>
                <FormattedMessage id="influencer_registration_desc" defaultMessage={"Please Enter your details and proceed"} />.
            </p>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {(form) => (
                    <Form className="mt-5">
                        <>
                            <div className="flex justify-center items-center">
                                <div className="relative rounded-full flex items-center justify-center my-5">
                                    <img
                                        src={
                                            image
                                                ? typeof image === "string"
                                                    ? image // Use string URLs
                                                    : URL.createObjectURL(image) // Use local preview
                                                : "/images/avatar.png"
                                        }
                                        alt="Profile"
                                        className="w-20 h-20 rounded-full object-cover border"
                                    />

                                    <label htmlFor="image-upload">
                                        {image ? (
                                            <div
                                                className="absolute -bottom-3 -right-2 rounded-full bg-primary p-2 "
                                            >
                                                <HiOutlinePencil className="text-xl text-white cursor-pointer" />
                                            </div>
                                        ) : (
                                            <IoIosAddCircle className="absolute -bottom-3 -right-2 text-primary cursor-pointer" size={40} />
                                        )}
                                    </label>
                                    <input
                                        id="image-upload"
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageUpload}
                                        className="hidden"
                                    />
                                </div>
                            </div>
                            <div className="gap-5 grid grid-cols-1 sm:grid-cols-2 items-center">
                                <div>
                                    <TextField
                                        type="text"
                                        field="name"
                                        label_text={<FormattedMessage id="name" defaultMessage="Name" />}
                                        form={form}
                                        isRequired
                                    />
                                </div>
                                <div>
                                    <TextField
                                        type="text"
                                        field="sur_name"
                                        label_text={<FormattedMessage id="surname" defaultMessage="Surname" />}
                                        form={form}
                                        isRequired

                                    />
                                </div>
                                <div className="">
                                    <TextField
                                        type="email"
                                        field="email"
                                        label_text={
                                            <FormattedMessage
                                                id="email"
                                                defaultMessage="email"
                                            />
                                        }
                                        form={form}
                                        isRequired

                                    />
                                </div>
                                <div>
                                    <DateField
                                        field="date_of_birth"
                                        label_text={<FormattedMessage id="date_of_birth" defaultMessage="Date of Birth" />}
                                        form={form}
                                        maxDate={new Date()}
                                        isRequired
                                    />
                                </div>
                                {/* <div>
                                    <TextField
                                        type="text"
                                        field="city"
                                        label_text={<FormattedMessage id="city" defaultMessage="City" />}
                                        form={form}
                                        isRequired

                                    />
                                </div>
                                <div>
                                    <TextField
                                        type="text"
                                        field="country"
                                        label_text={<FormattedMessage id="country" defaultMessage="Country" />}
                                        form={form}
                                        isRequired

                                    />
                                </div> */}
                                <div>
                                    <label className='text-xs font-medium inline-block'>
                                        <FormattedMessage id="address*" defaultMessage="Address*" />
                                    </label>
                                    <GooglePlacesAutocomplete
                                        apiKey={process.env.REACT_APP_PLACES_API_KEY}
                                        selectProps={{
                                            defaultValue: formData?.address
                                                ? {
                                                    label: formData?.address,
                                                    value: {
                                                        place_id: formData?.place_id,
                                                    },
                                                }
                                                : null,
                                            onChange: (place) => handleAddressSelect(place, form),
                                            placeholder: intl.formatMessage({ id: "address", defaultMessage: "Address" }),
                                            styles: selectStylesField(form.touched['address'] && form.errors['address']),
                                            filterOption: (option) => {
                                                console.log('option', option);
                                                // Filter out options where terms.length === 1
                                                return !(option?.data?.value?.terms && option?.data?.value?.terms?.length === 1);
                                            },
                                        }}
                                    />
                                    {form.errors.address && form.touched.address && (
                                        <p className="text-red-500 text-xs mt-1">{form.errors.address}</p>
                                    )}
                                </div>
                                <div>
                                    <SelectField
                                        options={CATEGORIES}
                                        field="niches"
                                        label_text={<FormattedMessage id="niches" defaultMessage="Niches" />}
                                        form={form}
                                        isMulti={true}
                                        isRequired

                                    />
                                </div>

                                <div>
                                    <SelectField
                                        options={GENDERS}
                                        field="gender"
                                        label_text={<FormattedMessage id="gender" defaultMessage="Gener" />}
                                        form={form}
                                        isRequired

                                    />
                                </div>
                                <div>
                                    <CurrencyField
                                        type="text"
                                        field="average_price"
                                        label_text={<FormattedMessage id="average_price" defaultMessage="Average Price" />}
                                        form={form}
                                        Icon={BiEuro}

                                        isRequired

                                    />
                                </div>

                                {/* <div className="" /> */}



                                <button
                                    type="button"
                                    onClick={() => handlePlatformSelect('instagram', form)}
                                    className={`relative px-4 py-2 border-2 h-[45px] sm:mt-2 rounded-md gap-x-2 flex items-center justify-center ${selectedPlatforms?.includes('instagram')
                                        ? 'border-primary text-white bg-primary'
                                        : form.errors.selectedPlatforms ? 'border-red-500'
                                            : 'border-gray-300'
                                        }`}
                                >
                                    <FaInstagram className={`${selectedPlatforms?.includes('instagram') ? 'text-white' : 'text-pink-500'}`} size={26} />
                                    <FormattedMessage id="instagram" defaultMessage={"Instagram"} />
                                    {selectedPlatforms?.includes('instagram') && (
                                        <FaRegCircleCheck className="absolute top-[13px] right-2 text-white" />
                                    )}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => handlePlatformSelect('tiktok', form)}
                                    className={`relative px-4 py-2 border-2 h-[45px] sm:mt-2 rounded-md flex gap-x-2 items-center justify-center ${selectedPlatforms?.includes('tiktok')
                                        ? 'border-primary text-white bg-primary'
                                        : form.errors.selectedPlatforms ? 'border-red-500'
                                            : 'border-gray-300'
                                        }`}
                                >
                                    <FaTiktok className={`${selectedPlatforms?.includes('tiktok') ? 'text-white' : 'text-black'}`} size={26} />
                                    <FormattedMessage id="tiktok" defaultMessage={"Tiktok"} />
                                    {selectedPlatforms?.includes('tiktok') && (
                                        <FaRegCircleCheck className="absolute top-[13px] right-2 text-white" />

                                    )}
                                </button>
                            </div>
                            {
                                (form.errors.selectedPlatforms || form.touched.selectedPlatforms) && (
                                    <p className="text-red-500 text-xs mt-1">{form.errors.selectedPlatforms}</p>
                                )
                            }

                            {/* Instagram Fields */}
                            {selectedPlatforms?.includes('instagram') && (
                                <div className="gap-5 grid grid-cols-1 sm:grid-cols-2 items-center mt-5">
                                    <div>
                                        <TextField
                                            type="text"
                                            field="instagram_name"
                                            label_text={<FormattedMessage id="instagram_name" defaultMessage="Instagram Name" />}
                                            form={form}
                                            isRequired

                                        />
                                    </div>
                                    <div>
                                        <TextField
                                            type="text"
                                            field="instagram_bio"
                                            label_text={<FormattedMessage id="instagram_bio" defaultMessage="Instagram Bio" />}
                                            form={form}
                                            isRequired

                                        />
                                    </div>
                                    <div>
                                        <CurrencyField
                                            type="text"
                                            field="instagram_followers"
                                            label_text={<FormattedMessage id="instagram_followers" defaultMessage="Instagram Followers" />}
                                            form={form}
                                            isRequired

                                        />
                                    </div>
                                    <div>
                                        <TextField
                                            type="text"
                                            field="instagram_engagement_metrics"
                                            label_text={<FormattedMessage id="instagram_engagement_metrics" defaultMessage="Instagram Engagement Rate" />}
                                            form={form}
                                            isRequired

                                        />
                                    </div>

                                </div>
                            )}

                            {/* TikTok Fields */}
                            {selectedPlatforms?.includes('tiktok') && (
                                <div className="gap-5 grid grid-cols-1 sm:grid-cols-2 items-center mt-5">
                                    <div>
                                        <TextField
                                            type="text"
                                            field="tiktok_name"
                                            label_text={<FormattedMessage id="tiktok_name" defaultMessage="TikTok Name" />}
                                            form={form}
                                            isRequired

                                        />
                                    </div>
                                    <div>
                                        <CurrencyField
                                            type="text"
                                            field="tiktok_followers"
                                            label_text={<FormattedMessage id="tiktok_followers" defaultMessage="TikTok Followers" />}
                                            form={form}
                                            isRequired

                                        />
                                    </div>
                                    <div>
                                        <TextField
                                            type="text"
                                            field="tiktok_engagement_metrics"
                                            label_text={<FormattedMessage id="tiktok_engagement_metrics" defaultMessage="TikTok Engagement Rate" />}
                                            form={form}
                                            isRequired

                                        />
                                    </div>
                                </div>
                            )}

                            <div className='mt-4'>
                                <button
                                    className='flex items-start space-x-3' type="button"
                                >
                                    <div className={`flex items-center justify-center space-x-4 `}>
                                        <input
                                            className='transform flex-shrink-0 scale-150  bg-white'
                                            type="checkbox"
                                            onClick={() => {
                                                form.setFieldValue("consent", !form.values.consent)
                                            }}
                                            checked={form.values.consent}
                                        />
                                        <p className='text-xs 2k:text-sm imac:text-base text-secondary font-medium'>
                                            <FormattedMessage
                                                id="policy_consent"
                                                defaultMessage="I have read and agree with {privacyPolicy}*"
                                                values={{
                                                    privacyPolicy: (
                                                        <Link href="/privacy" target="_blank" className="underline">
                                                            <FormattedMessage id="privacy_policy" defaultMessage="privacy policy" />
                                                        </Link>
                                                    ),
                                                }}
                                            />
                                        </p>

                                    </div>
                                </button>
                                {
                                    form.errors['consent'] &&
                                    <p className="-ml-1 mt-1 text-xs text-red-500">
                                        <ErrorMessage name={'consent'} />
                                    </p>
                                }
                            </div>

                            <div className="mt-4">
                                <button
                                    className='flex items-start space-x-3'

                                    type="button"
                                >
                                    <div className={`flex items-center justify-center space-x-4 `}>
                                        <input
                                            onClick={() => {
                                                form.setFieldValue("marketing", !form.values.marketing)

                                            }}
                                            className='transform flex-shrink-0 scale-150 rounded-none  bg-white'
                                            type="checkbox"
                                            checked={form.values.marketing}
                                        />
                                        <p className='text-xs 2k:text-sm imac:text-base text-secondary text-start font-medium'>
                                            <FormattedMessage
                                                id="marketing_consent"
                                                defaultMessage="I wish to receive informative or promotional communications about the activities of Influencee, including invitations to events or other initiatives, press releases, and newsletters, also through automated communication systems in accordance with the {privacyPolicy}."
                                                values={{
                                                    privacyPolicy: (
                                                        <Link href="/privacy" target="_blank" className="underline">
                                                            <FormattedMessage id="privacy_policy" defaultMessage="privacy policy" />
                                                        </Link>
                                                    ),
                                                }}
                                            />
                                        </p>

                                    </div>
                                </button>
                                {
                                    form.errors.marketing && form.touched.marketing &&
                                    <p className='text-red-500 text-xs'>
                                        {form.errors.marketing}

                                    </p>
                                }
                            </div>

                            <div className="mt-8">
                                <div className=" items-center pt-3 pb-3">
                                    <button
                                        type="submit"
                                        disabled={form.isSubmitting}
                                        className="block w-full btn btn-primary"
                                    >
                                        <p>
                                            {form.isSubmitting ? (
                                                <BiLoaderAlt className="animate-spin text-white text-2xl mx-auto" />
                                            ) : (
                                                <div className="flex space-x-2 justify-center items-center">
                                                    <span><FormattedMessage id="proceed" defaultMessage={"Proceed"} /></span>
                                                    <FaArrowRightLong className="text-xl mx-auto text-white" />
                                                </div>
                                            )}
                                        </p>
                                    </button>
                                </div>
                            </div>
                        </>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default InfluencerForm;